import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { FaCheckCircle } from 'react-icons/fa'

// CONSTANTS
import colors, { tenantColors } from '../_constants/colors'

// Assets
import InvoiceIcon from '../assets/img/icnorange.png'
import SingleInvoiceIcon from '../assets/img/single_invoice_icon4.png'
import InvoiceGreenCheck from '../assets/img/invoices_green_check.png'

import { formatCurrency } from '../_helpers/formatting'

// Styled Components
const StyledInvoices = styled.div`
  .parent-banner,
  .invoices .invoice {
    background-color: ${colors.GREY};
    border: 2px solid ${colors.DARK_GREY};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 15px;
    align-items: center;
    text-align: center;
    transition: all 0.2s ease-in-out;

    &:hover {
      border-color: ${(props) => tenantColors[props.tenant].secondary || colors.DEFAULT_SECONDARY};
    }

    @media screen and (min-width: 700px) {
      flex-direction: row;
      text-align: left;

      & > * {
        margin-bottom: 0px !important;
      }

      img {
        margin-right: 10px;
      }

      .amount {
        margin-left: auto;
      }
    }

    & > * {
      &:last-child {
        margin-bottom: 0px;
      }
    }

    .main-stats {
      display: flex;
      flex-direction: column;

      & > * {
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0px;
        }
      }

      .awaiting-approval-text {
        color: #fbaf5d;
      }

      .num-invoices {
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }

  .parent-banner {
    border-color: ${(props) => props.isOpen && (tenantColors[props.tenant].secondary || colors.DEFAULT_SECONDARY)};
    cursor: pointer;

    & > * {
      margin-bottom: 25px;
    }

    img {
      height: 40px;
    }

    .num-customers,
    .amount {
      font-size: 20px;
    }
  }

  .invoices {
    .invoice {
      padding: 10px 25px;
      margin-bottom: 10px;

      &:first-child {
        margin-top: 10px;
      }

      &:last-child {
        margin-bottom: 0px;
      }

      & > * {
        margin-bottom: 5px;
      }

      img {
        height: 40px;
      }

      .num-customers,
      .amount {
        font-size: 1.25em;
      }

      .num-invoices {
        .check-mark {
          color: ${colors.MATERIAL_GREEN};
          transform: translateY(2px);
          font-size: 0.9em;
        }
      }
    }
  }
`

class Invoices extends React.Component {
  state = {
    isOpen: false,
  }

  toggleIsOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render() {
    const { isOpen } = this.state
    const { tenant, activeCustomers, totalNumInvoices, data, deal } = this.props
    const InvoiceImg = data && data.deal_status === `submitted` ? InvoiceGreenCheck : InvoiceIcon
    let customers = (data && data.customers) || activeCustomers
    let totalFaceValue = (data && data.totalFaceValue) || this.props.totalFaceValue
    if (!totalFaceValue) {
      totalFaceValue = customers.reduce((totalVal, customer) => {
        return totalVal + parseInt(customer.faceValue)
      }, 0)
    }
    const totalCustomersLabel = customers.length !== 1 ? 'Customers' : 'Customer'
    return (
      <StyledInvoices isOpen={isOpen} tenant={tenant}>
        <div className={`parent-banner`} onClick={() => this.toggleIsOpen()}>
          <img alt={`Invoice Icon`} src={InvoiceImg} />
          <div className={`main-stats`}>
            <span className={`num-customers`}>
              {customers.length} {totalCustomersLabel}
            </span>
            {!data && totalNumInvoices && <span className={`num-invoices`}>{totalNumInvoices} Invoice(s)</span>}
            {data && data.deal_status === `submitted` && (
              <p className={`awaiting-approval-text`}>Awaiting Final Approval and Rates</p>
            )}
          </div>
          {totalFaceValue !== null && <span className={`amount`}>{formatCurrency(totalFaceValue)}</span>}
        </div>
        {customers.length > 0 && isOpen && (
          <div className={`invoices`}>
            {customers.map((invoice, i) => (
              <div className={`invoice`} key={i}>
                <img alt={`Single Invoice Icon`} src={SingleInvoiceIcon} />
                <div className={`main-stats`}>
                  <span className={`invoice-name`}>{invoice.name}</span>
                  <span className={`num-invoices`}>
                    {invoice.numInvoices} Invoice{invoice.numInvoices !== 1 ? 's' : ''}
                    {invoice.preapproved && <FaCheckCircle className={`check-mark`} />}
                  </span>
                </div>
                {invoice.faceValue !== null && (
                  <span className={`amount`}>{formatCurrency(parseInt(invoice.faceValue))}</span>
                )}
              </div>
            ))}
          </div>
        )}
      </StyledInvoices>
    )
  }
}

function mapStateToProps(state) {
  const { env, accounting, deal } = state
  return {
    tenant: env.tenant,
    activeCustomers: accounting.activeCustomers,
    totalNumInvoices: deal.deal.totalNumInvoices,
    totalFaceValue: deal.deal.totalFaceValue,
    deal,
  }
}

const connectedInvoices = connect(mapStateToProps, null)(Invoices)
export { connectedInvoices as Invoices }
